module.exports = __webpack_public_path__ + "static/4-18703594c3a49b9aa5a705d99d5b069f.jpg";